export default "__VITE_ASSET__69f4145e__"